import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";
import { clientUrl } from "@/lib/api";
import { SectionHeader } from "./Services";

export default function Clients({ clients }) {
  return (
    <section id="clientes" data-testid={HOME.clients} className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Clientes" title="Acompañamos a productoras, pymes y estudios" sub="Empresas de distintos sectores que confían en nosotros para mantener su infraestructura y sus transmisiones funcionando." />
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-line-2 border border-line-2">
          {clients.map((c, i) => (
            <motion.div key={c.id || c.filename}
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i*0.04 }}
              className="bg-base aspect-[3/2] flex items-center justify-center p-5 group"
              title={c.name}
            >
              <img src={clientUrl(c)} alt={c.name} className="client-logo max-h-9 max-w-[120px] object-contain" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
